import { Reducer } from 'redux';
import { NotificationsState, NotificationsTypes } from './types';

const INITIAL_STATE: NotificationsState = {
  notification: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<NotificationsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NotificationsTypes.LOAD_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case NotificationsTypes.LOAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notification: action.payload.notification,
        loading: false,
        error: false,
      };
    case NotificationsTypes.LOAD_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notification: 0,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
};

export default reducer;
